/* eslint no-console: 0, no-native-reassign: 0, no-undef: 0, camelcase: 0 */
/* global Stripe, listingJSON */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export class ErrorPage extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { link, button, linkFn } = this.props;
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <div className="wrap">
        <section className="center-block error-page">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-sm-offset-3">
                <div className="error-col">
                  <i className="ico ico-lg icon-attention text-gray"></i>
                  <h2 className="text-center">
                    <FormattedMessage
                      id="web_2.error_page.something_wrong"
                      defaultMessage="Something went wrong"
                    />
                  </h2>
                  <p>
                    <FormattedMessage
                      id="web_2.error_page.working_fix"
                      defaultMessage="We're working on a fix right now, but in the meantime you can contact {support} or try again later."
                      values={{
                        support: (
                          <a href={`https://support.peerspace.com/hc/${zendeskLocale}`}>
                            <FormattedMessage
                              id="web_2.error_page.support"
                              defaultMessage="Peerspace Support"
                            />
                          </a>
                        )
                      }}
                    />
                  </p>
                  <a href={link} onClick={linkFn} className="btn btn-primary btn-block hero text-center" role="button">{button}</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
